import itemDetailsReducer from "./reducers";

export default itemDetailsReducer;
